import { ContactSet } from '@square/dashboard-data/models/squareup/rolodex/contact-set';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
export const ContactBatchActionStatus = ProtoBaseModel.extend({
  totalSuccessCount: attr(Number),
  totalErrorCount: attr(Number)
});
export const AddContactsToGroupsRequest = ProtoBaseModel.extend({
  merchantToken: attr(String),
  contactSet: attr(ContactSet),
  groupTokens: repeated(String)
});
export const AddContactsToGroupsResponse = ProtoBaseModel.extend({
  success: attr(Boolean),
  batchActionStatus: attr(ContactBatchActionStatus)
});
export const RemoveContactsFromGroupsRequest = ProtoBaseModel.extend({
  merchantToken: attr(String),
  contactSet: attr(ContactSet),
  groupTokens: repeated(String)
});
export const RemoveContactsFromGroupsResponse = ProtoBaseModel.extend({
  success: attr(Boolean),
  batchActionStatus: attr(ContactBatchActionStatus)
});